var currentImgIndex = 0,
	galleryContainer = document.querySelector('.gallery-container'),
	galleryImages = galleryContainer.querySelectorAll('.bg-wrapper'),
	galleryImagesLength = galleryImages.length,
	galleryModal = document.getElementById('image-gallery-modal');

[].slice.call(galleryImages).forEach(function(figure) {
	figure.addEventListener('click', function() {
		openGalleryModal(figure);
	});
});

function openGalleryModal(figure) {
	var img = figure.querySelector('img');

	galleryModal.querySelector('img').src = img.getAttribute((!img.classList.contains('first') ? 'data-' : '')+'src');

	currentImgIndex = [].indexOf.call(galleryImages, figure);

	Velocity(galleryModal, {opacity: [1,0]}, {duration: 300, display: 'block'});

	galleryModal.querySelector('.close-modal').focus();

	skipLinkToggleDisplay(true);

	setFocus(true, false);
}

[].slice.call(galleryModal.querySelectorAll('.next, .prev')).forEach(function(button) {
	button.addEventListener('click', function() {
		setGalleryImage(this.className);
	});
});

document.addEventListener('keydown', function(e) {
	var activeElement = document.activeElement;

	if(e.key == 'Enter' && activeElement.classList.contains('bg-wrapper') && activeElement.getAttribute('aria-role') == 'button')
		openGalleryModal(activeElement);

	if(window.getComputedStyle(galleryModal).display == 'block') {
		var dir = '';

		if(e.key == 'ArrowRight') 
			dir = 'next';
		else if(e.key == 'ArrowLeft')
			dir = 'prev';

		if(dir) {
			setGalleryImage(dir);
			galleryModal.querySelector('.'+dir).focus();
		}
	}
});

function setGalleryImage(dir) {
	currentImgIndex = dir == 'next' ? (currentImgIndex == galleryImagesLength-1 ? 0 : currentImgIndex+1) : (!currentImgIndex ? galleryImagesLength-1 : currentImgIndex-1);

	var img = galleryImages[currentImgIndex].querySelector('img');

	galleryModal.querySelector('img').src = img.getAttribute((!img.classList.contains('first') ? 'data-' : '')+'src');
}